import { z } from 'zod';

export type NavigationEventType =
  | 'PageView'
  | 'NavigationMenuClick'
  | 'NavigationDropdownExpand'
  | 'NavigationDropdownDismiss'
  | 'Navigation_ModalSkipClicked'
  | 'Navigation_ModalContinueClicked'
  | 'Navigation_ModalFinishClicked'
  | 'Navigation_Clicked5Times';

// Navigation event payload schemas
export const PageViewPayloadSchema = z.object({
  path: z.string(),
  title: z.string(),
});

export const NavVariant = z.enum(['legacy', 'legacy_mobile', 'new_v1']);
export type NavVariant = z.infer<typeof NavVariant>;

export const NavigationMenuEventBaseSchema = z.object({
  menuLabel: z.string(),
  nav_type: NavVariant,
});

export const NavigationModalEventBaseSchema = z.object({
  feature_name: z.string(),
  feature_version: z.string(),
  step_number: z.number(),
  nav_type: NavVariant,
});

export const NavigationMenuClickPayloadSchema = NavigationMenuEventBaseSchema.extend({
  url: z.string(),
});

export const NavigationDropdownExpandPayloadSchema = NavigationMenuEventBaseSchema.extend({
  dropdownId: z.string(),
});

export const NavigationDropdownDismissPayloadSchema = NavigationMenuEventBaseSchema.extend({
  dropdownId: z.string(),
  dismissType: z.enum(['click_outside', 'escape_key']).optional(),
});

export const Navigation_ModalSkipClickedPayloadSchema = NavigationModalEventBaseSchema;
export const Navigation_ModalContinueClickedPayloadSchema = NavigationModalEventBaseSchema;
export const Navigation_ModalFinishClickedPayloadSchema = NavigationModalEventBaseSchema;

export const Navigation_Clicked5TimesPayloadSchema = z.object({
  eventName: z.literal('Navigation_Clicked5Times'),
});

export type NavigationEventTypePayloadMap = {
  PageView: z.infer<typeof PageViewPayloadSchema>;
  NavigationMenuClick: z.infer<typeof NavigationMenuClickPayloadSchema>;
  NavigationDropdownExpand: z.infer<typeof NavigationDropdownExpandPayloadSchema>;
  NavigationDropdownDismiss: z.infer<typeof NavigationDropdownDismissPayloadSchema>;
  Navigation_ModalSkipClicked: z.infer<typeof Navigation_ModalSkipClickedPayloadSchema>;
  Navigation_ModalContinueClicked: z.infer<typeof Navigation_ModalContinueClickedPayloadSchema>;
  Navigation_ModalFinishClicked: z.infer<typeof Navigation_ModalFinishClickedPayloadSchema>;
  Navigation_Clicked5Times: z.infer<typeof Navigation_Clicked5TimesPayloadSchema>;
};

export const NavigationEventSchemaMap = {
  PageView: PageViewPayloadSchema,
  NavigationMenuClick: NavigationMenuClickPayloadSchema,
  NavigationDropdownExpand: NavigationDropdownExpandPayloadSchema,
  NavigationDropdownDismiss: NavigationDropdownDismissPayloadSchema,
  Navigation_ModalSkipClicked: Navigation_ModalSkipClickedPayloadSchema,
  Navigation_ModalContinueClicked: Navigation_ModalContinueClickedPayloadSchema,
  Navigation_ModalFinishClicked: Navigation_ModalFinishClickedPayloadSchema,
  Navigation_Clicked5Times: Navigation_Clicked5TimesPayloadSchema,
};
